import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Container } from '@mui/material';

import { PATH_DASHBOARD } from '@/routes/paths';
import { Iconic } from '@/commons/iconic';
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { useQuery } from '@tanstack/react-query';
import {findUsersByBranch, getUsersService} from '@/services';
import ListPage from '@/components/Table';
import { translates } from '@/utils/translate';
import { TABLE_HEAD_USERS } from '../utils/contants';
import { IUserAccountGeneral } from '../types';
import { ListActionsUsers } from '../actions-list';

export default function UserListPage() {
  const navigate_reservations: any = {
    view: PATH_DASHBOARD.reservations.view,
    edit: PATH_DASHBOARD.reservations.edit,
  };
  const title = translates.users;

  const links = [
    {
      name: translates.dashboard,
      href: PATH_DASHBOARD.root,
    },
    {
      name: translates.users,
      href: PATH_DASHBOARD.users.list,
    },
  ];

  const { isLoading, data } = useQuery({
    queryKey: ['users'],
    queryFn: findUsersByBranch,
  });

  return (
    <>
      <Helmet>
        <title>
          {import.meta.env.VITE_TITLE_BUSINESS}: {title} List
        </title>
      </Helmet>
      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={`${translates.list} ${title} `}
          links={links}
          action={[
            <Button
              component={RouterLink}
              to={PATH_DASHBOARD.users.new}
              variant="contained"
              startIcon={<Iconic icon="eva:plus-fill" />}
            >
              {translates.new + translates.user}
            </Button>,
          ]}
        />

        <ListPage<IUserAccountGeneral, string>
          data={data}
          navigateHandle={navigate_reservations}
          actions={ListActionsUsers}
          isLoading={isLoading}
          dataStruct={TABLE_HEAD_USERS}
          actionParamId="uid"
        />
      </Container>
    </>
  );
}
